import React from 'react'
import Sliders from './partials/Sliders'
import { Helmet } from 'react-helmet'

export default function LatestOffer() {
  return (
    <>
 {/* Meta Tags for SEO */}
      <Helmet>
        <title>Latest Offers - V Hotel The Grand Shoba</title>
        <meta name="description" content="Explore the latest offers and exclusive deals at V Hotel The Grand Shoba near Delhi Airport. Book your luxury stay with us now!" />
        <meta property="og:title" content="Latest Offers - V Hotel The Grand Shoba" />
        <meta property="og:description" content="Discover our latest offers for luxurious stays and exceptional experiences at V Hotel The Grand Shoba, located near IGI Airport." />
        <meta property="og:image" content="images/home/corporate-slider.jpg" />
      </Helmet>


    <div className="container">
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-12">
                    <div className="letest-offer ">
                        <h1 className='text-center text-uppercase me-5'>Latest Offers</h1>
                        <p>Discover exclusive stays and exceptional experiences at our elegantly designed hotel near Delhi Airport.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Sliders/>
    </>
  )
}
